import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthorizeNetService } from 'app/services/authorizeNet.service';

@Component({
  selector: 'app-authorized-payment',
  templateUrl: './authorized-payment.component.html',
  styleUrls: ['./authorized-payment.component.scss']
})
export class AuthorizedPaymentComponent {
  @Input() invoice: any; // passed from parent
  @Input() parentId: string = '';
  @Input() parentEmail: string = '';
  @Output() paymentSuccess = new EventEmitter<any>();
  @Output() paymentFailure = new EventEmitter<string>();

  paymentProcessing = false;

  paymentForm = this.fb.group({
    cardNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{13,16}$/)]],
    expMonth: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[0-2])$/)]],
    expYear: ['', [Validators.required, Validators.pattern(/^[0-9]{4}$/)]],
    cvv: ['', [Validators.required, Validators.pattern(/^[0-9]{3,4}$/)]],
    email: ['']
  });

  constructor(
    private fb: FormBuilder,
    private authorizeNetService: AuthorizeNetService
  ) {}

  ngOnInit(): void {
  if (this.parentEmail) {
    this.paymentForm.patchValue({ email: this.parentEmail });
  }
}

  async submitPayment() {
    if (this.paymentForm.invalid || this.paymentProcessing) return;

    this.paymentProcessing = true;

    try {
      const paymentData = {
        cardData: {
          cardNumber: this.paymentForm.value.cardNumber?.replace(/\s+/g, ''),
          expirationDate: `${this.paymentForm.value.expMonth}${this.paymentForm.value.expYear?.slice(-2)}`,
          cardCode: this.paymentForm.value.cvv
        },
        amount: this.invoice.Program_Fee__c,
        invoiceId: this.invoice.Id,
        parentIdOrUid: this.parentId,
        email: this.paymentForm.value.email?.trim() || null
      };

      const result = await this.authorizeNetService.processPayment(paymentData).toPromise();

      if (result?.success) {
        this.paymentSuccess.emit(result);
      } else {
        this.paymentFailure.emit(result?.message || 'Payment failed');
      }
    } catch (error: any) {
      this.paymentFailure.emit(error.message || 'Payment processing error');
    } finally {
      this.paymentProcessing = false;
    }
  }
}
